export enum StatusPedidoEnum {
   Aguardando = 1,
   Aceito = 2,
   EmPreparo = 3,
   SaiuEntrega = 4,
   PedidoFinalizado = 5,
   Rejeitado = 6
}
